module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("下单")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportData()
      }
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('xcurd', {
    ref: "sendOrderTable",
    attrs: {
      "topBtns": _vm.sendTable.topBtns,
      "dialogs": _vm.sendTable.dialogs,
      "table": _vm.sendTable.table
    },
    on: {
      "clickRowBtn": _vm.sendTableRowBtn,
      "clickMultiBtn": function($event) {},
      "clickTopBtn": function($event) {}
    }
  }), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "title": _vm.orderForm.type == 'add' ? '下单' : '订单详情',
      "size": "small"
    },
    model: {
      value: (_vm.orderForm.visible),
      callback: function($$v) {
        _vm.orderForm.visible = $$v
      },
      expression: "orderForm.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.orderForm.data,
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户地区"
    }
  }, [(_vm.orderForm.type == 'add') ? _c('el-cascader', {
    attrs: {
      "options": _vm.areaData.list,
      "props": _vm.areaData.props
    },
    on: {
      "active-item-change": _vm.areaItemChange
    },
    model: {
      value: (_vm.areaData.value),
      callback: function($$v) {
        _vm.areaData.value = $$v
      },
      expression: "areaData.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderForm.type != 'add') ? _c('div', [_vm._v(_vm._s(_vm.orderForm.data._area.fullname))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支付方式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.orderForm.data.pay_type),
      callback: function($$v) {
        _vm.orderForm.data.pay_type = $$v
      },
      expression: "orderForm.data.pay_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("客户付款")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("商家付款")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户姓名"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.data.name),
      callback: function($$v) {
        _vm.orderForm.data.name = $$v
      },
      expression: "orderForm.data.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.data.tel),
      callback: function($$v) {
        _vm.orderForm.data.tel = $$v
      },
      expression: "orderForm.data.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户详细地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.orderForm.data.address),
      callback: function($$v) {
        _vm.orderForm.data.address = $$v
      },
      expression: "orderForm.data.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单详情"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.orderForm.data.content2),
      callback: function($$v) {
        _vm.orderForm.data.content2 = $$v
      },
      expression: "orderForm.data.content2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商家备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4
    },
    model: {
      value: (_vm.orderForm.data.remark_seller),
      callback: function($$v) {
        _vm.orderForm.data.remark_seller = $$v
      },
      expression: "orderForm.data.remark_seller"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h2', [_vm._v("服务项目")]), _vm._v(" "), _c('div', {
    staticClass: "servCart"
  }, [_c('div', {
    staticClass: "servCartList"
  }, _vm._l((_vm.orderForm.data.servs), function(item, index) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "it"
    }, [(_vm.orderForm.type == 'add') ? _c('el-select', {
      attrs: {
        "placeholder": "请输入关键词或拼音简写"
      },
      on: {
        "change": _vm.updatePrice
      },
      model: {
        value: (item._serv),
        callback: function($$v) {
          item._serv = $$v
        },
        expression: "item._serv"
      }
    }, _vm._l((_vm.sellerServ), function(it) {
      return _c('el-option', {
        attrs: {
          "label": it.name,
          "value": it.id
        }
      })
    })) : _c('el-select', {
      attrs: {
        "disabled": "",
        "placeholder": "请输入关键词或拼音简写"
      },
      on: {
        "change": _vm.updatePrice
      },
      model: {
        value: (item._serv.name),
        callback: function($$v) {
          item._serv.name = $$v
        },
        expression: "item._serv.name"
      }
    }, _vm._l((_vm.sellerServ), function(it) {
      return _c('el-option', {
        attrs: {
          "label": it.name,
          "value": it.id
        }
      })
    }))], 1), _vm._v(" "), _c('div', {
      staticClass: "it"
    }, [_c('el-input-number', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "min": 1,
        "step": 1,
        "disabled": _vm.orderForm.type != 'add'
      },
      on: {
        "input": _vm.updatePrice
      },
      model: {
        value: (item.count),
        callback: function($$v) {
          item.count = $$v
        },
        expression: "item.count"
      }
    })], 1), _vm._v(" "), (_vm.orderForm.data.servs.length != 1 && _vm.orderForm.type == 'add') ? _c('div', {
      staticClass: "opt"
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.removeServCart(index)
        }
      }
    })], 1) : _vm._e()])
  })), _vm._v(" "), (_vm.orderForm.type == 'add') ? _c('div', {
    staticClass: "opt-add"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "icon": "plus"
    },
    on: {
      "click": function($event) {
        _vm.addServCart()
      }
    }
  }, [_vm._v("添加服务")])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "servCartResult"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("价格")]), _vm._v(" "), (_vm.orderForm.type != 'add') ? _c('div', {
    staticClass: "val"
  }, [_vm._v("¥" + _vm._s(_vm.orderForm.data.price))]) : _vm._e(), _vm._v(" "), (_vm.orderForm.type == 'add') ? _c('div', {
    staticClass: "val"
  }, [_vm._v("¥" + _vm._s(_vm.orderForm.price.seller))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panel",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "hd"
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "detail",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [(_vm.tumbs.length > 0) ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("图片")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, _vm._l((_vm.tumbs), function(t) {
    return _c('img', {
      attrs: {
        "src": 'http://www.888jigong.com/upload/wximg/' + t + '.jpg',
        "width": "100%",
        "alt": ""
      }
    })
  }))]) : _vm._e()])])])])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.orderForm.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (_vm.orderForm.type == 'add') ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addSubmit()
      }
    }
  }, [_vm._v("下 单")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-35b1b6c2!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/store/order.vue
// module id = 217
// module chunks = 2